import { RadioGroup, Option } from '@op/opds.opux';
import React from 'react';
import { IconPerson } from '@op/opds.opux-icons/insurance';
import { Message, useMessageGetter } from '@messageformat/react';
import { riskProfiles } from './taskoneoptions';
import Donut from '../Donut/Donut';
import ProductTypeList from './ProductTypeList';
import styles from './RiskProfiles.module.scss';

interface Props {
  selectedValue: string;
  setSelectedValue: React.Dispatch<React.SetStateAction<string>>;
}

const RiskProfiles = (props: Props): JSX.Element => {
  const { selectedValue, setSelectedValue } = props;
  const getMessage = useMessageGetter('');

  const buildScreenReaderLabel = (riskProfile: (typeof riskProfiles)[0]): string => {
    let label = `${getMessage(riskProfile.name)}. ${getMessage(riskProfile.description)} `;
    riskProfile.data
      .filter((dataItem) => dataItem.value > 0)
      .forEach((dataItem) => {
        label += `${getMessage(dataItem.label)}: ${dataItem.value}%. `;
      });
    return label;
  };

  return (
    <RadioGroup
      onChange={(_ev, value) => {
        setSelectedValue(value);
      }}
      value={selectedValue}
    >
      {riskProfiles.map((riskProfile, index) => {
        const value = index.toString();
        return (
          <div key={riskProfile.id} className={styles.container}>
            <div className={styles.content}>
              <div className={styles.riskProfileContainer}>
                <Option
                  data-testid={`course7-task1-items-${riskProfile.id}`}
                  key={riskProfile.id}
                  value={value}
                  labelProps={{
                    className: styles.label,
                  }}
                >
                  <span className="sr-only">{buildScreenReaderLabel(riskProfile)}</span>
                </Option>
                <div
                  className={styles.description}
                  onClick={() => setSelectedValue(value)}
                  aria-hidden="true"
                >
                  <IconPerson size="large" />
                  <div>
                    <p className="opds-styles-v1-text-body-xl">
                      <Message id={riskProfile?.name} />
                    </p>
                    <p className="opds-styles-v1-text-body-xs">
                      <Message id={riskProfile?.description} />
                    </p>
                  </div>
                </div>
              </div>
              <div
                className={styles.graphContainer}
                onClick={() => setSelectedValue(value)}
                aria-hidden="true"
              >
                <Donut data={riskProfiles[index].data} isSmall />
                <ProductTypeList data={riskProfiles[index].data} />
              </div>
            </div>
          </div>
        );
      })}
    </RadioGroup>
  );
};

export default RiskProfiles;
